import { SegmentedControl, Pill } from '@shared/ui';
import type { Cadence } from '../api';

interface BillingToggleProps {
  cadence: Cadence;
  onChange: (next: Cadence) => void;
  /** Null hides the chip entirely — see `computeSavePct` in `SubscribePage.tsx`. */
  savePct: number | null;
}

/**
 * Figma "Monthly billing / Annually billing" pill toggle. Reuses the shared `SegmentedControl`
 * (already matches the spec verbatim: `--canvas-inset` track, white active pill + `shadow-card`,
 * 10px uppercase labels) and just adds the `SAVE {pct}%` chip onto the annual option's label.
 */
export function BillingToggle({ cadence, onChange, savePct }: BillingToggleProps) {
  return (
    <SegmentedControl<Cadence>
      value={cadence}
      onChange={onChange}
      ariaLabel="Billing cadence"
      options={[
        { value: 'monthly', label: 'Monthly billing' },
        {
          value: 'annual',
          label: (
            // `.pill` (via <Pill>) sets its own explicit text-transform/size/tracking, so it
            // renders correctly regardless of the ancestor button's uppercase label styling —
            // no need to fight inheritance here.
            <span className="inline-flex items-center gap-1.5">
              Annually billing
              {savePct != null && (
                <Pill bg="var(--chip-strong)" fg="var(--chip-text)">
                  Save {savePct}%
                </Pill>
              )}
            </span>
          ),
        },
      ]}
    />
  );
}
